export enum DisputeProductType {
  SERVICES = "SERVICES",
  MERCHANDISE = "MERCHANDISE",
}
